export const environment = {
  production: false,
  name: "test",
  baseURL: "https://test-api.hissa.com/",
  googleSignInURL: "https://test-api.hissa.com/google/signin",
  linkedInSignInURL: "https://test-api.hissa.com/linkedin/signin",
  googleSignUpURL: "https://test-api.hissa.com/google/signup",
  linkedInSignUpURL: "https://test-api.hissa.com/linkedin/signup",
  empPortalUrl: "https://dev-my.hissa.com",
  optionsUrl: "https://test-options.hissa.com",
  newCaptableBaseUrl : "https://test-captable-api.hissa.com/v1",
  newCaptableUrl : "https://test-captable.hissa.com"
};
